import React, { Fragment, useState } from "react";
import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  TableHead,
} from "@mui/material";
import { EmailRow } from "./EmailRow";
import { FileRow } from "./FileRow";
import { grey } from "@mui/material/colors";

const Normal = ({ data = [], refresh }) => {
  const [expandRow, setExpandRow] = useState(null);

   window.data = data;

  return (
    <TableContainer
      sx={{ overflow: "auto", height: "100%", scrollbarGutter: "stable" }}
    >
      <Table
        size="small"
        stickyHeader
        sx={{ tableLayout: "fixed", width: "100%" }}
      >
        <TableHead>
          <TableRow
            sx={{ "& .MuiTableCell-stickyHeader": { bgcolor: grey[300] } }}
          >
            <TableCell width={"25%"}>Filename</TableCell>
            <TableCell width={"15%"}>Payee Name</TableCell>
            <TableCell>Bill Number</TableCell>
            <TableCell>Bill Date</TableCell>
            <TableCell>Amount</TableCell>
            <TableCell align="center">Status</TableCell>
            <TableCell align="center">Action</TableCell>
            <TableCell align="center">Download</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {data.map((email) => {
            let files = email["files"];
            let email_id = email["_id"];
            return (
              <Fragment key={email_id}>
                <EmailRow
                  email={email}
                  setExpandRow={setExpandRow}
                  expandRow={expandRow}
                />
                {expandRow === email_id &&
                  files.map((file) => (
                    <FileRow
                      key={file["_id"]}
                      file={file}
                      email={email}
                      refresh={refresh}
                    />
                  ))}
              </Fragment>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default Normal;
